import { mainAPI, handleApiError } from "../api";

import { ApiErrorResponse } from "../types/api/error";
import {
  CategoriesListRequest,
  CreateCategoryRequest,
  DeleteCategoryRequest,
  CategoryResponse,
} from "../types/api/categories";

const path = `/metadata/admin/${process.env.REACT_APP_API_VERSION}/categories`;

// Категории (Разделы) - Получить список
export function fetchCategories(params: CategoriesListRequest) {
  return mainAPI.get<CategoryResponse[]>(`${path}`, { params }).then(
    (res) => {
      const countHeader = res.headers["count"];
      return Promise.resolve({
        list: res.data,
        totalCount: countHeader,
      });
    },
    (error) => handleApiError(error)
  );
}

// Категории (Разделы) - Получить запись
export function fetchCategory(category_id: string) {
  return mainAPI.get(`${path}/${category_id}`).then(
    (res) => {
      return Promise.resolve(res.data as CategoryResponse);
    },
    (error) => handleApiError(error)
  );
}

// Категории (Разделы) - Создать
export function createCategory(request: CreateCategoryRequest) {
  return mainAPI.post<CategoryResponse>(`${path}`, request).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(
        new Error(apiError?.detail || "Ошибка при создании раздела")
      );
    }
  );
}

// Категории (Разделы) - Изменить
export function editCategory(
  category_id: string,
  request: CreateCategoryRequest
) {
  return mainAPI.put<CategoryResponse>(`${path}/${category_id}`, request).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(
        new Error(apiError?.detail || "Ошибка при изменении раздела")
      );
    }
  );
}

// Категории (Разделы) - Удалить
export function deleteCategory(request: DeleteCategoryRequest) {
  return mainAPI.post(`${path}/delete`, request).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      const apiError: ApiErrorResponse = error.response?.data;
      return Promise.reject(
        new Error(apiError?.detail || "Ошибка при удалении раздела")
      );
    }
  );
}
